import { produce } from "immer";
import ACTIONS from "../actions/types.actions";

const market = produce((draft, action) => {
  switch (action.type) {
    case ACTIONS.MARKET_REQUEST:
      draft[action.key] = true;
      return draft;
    case ACTIONS.MARKET_SUGGESTION_REQUEST:
      draft.suggestionLoading = true;
      return draft;
    case ACTIONS.MARKET_SUGGESTION_SUCCESS:
      draft.suggestionLoading = false;
      draft.error = null;
      return draft;
    case ACTIONS.MARKET_SUCCESS:
      draft.loading = false;
      draft.error = null;
      draft.value = action.response;
      return draft;
    case ACTIONS.GET_ALL_MARKETS_SUCCESS:
      draft.loading = false;
      draft.error = null;
      draft.list = action.response.list;
      draft.pagination = action.response.pagination;
      return draft;
    case ACTIONS.GET_ALL_MARKETS_SELECTED_SUCCESS:
      draft.loading = false;
      draft.error = null;
      draft.selectedList = action.response.selectedList;
      draft.pagination = action.response.pagination;
      return draft;
    case ACTIONS.ACTIVE_MARKETS_SUCCESS:
      draft.loading = false;
      draft.error = null;
      draft.activeList = action.response;
      return draft;
    case ACTIONS.GET_MARKET_BY_ID_SUCCESS:
      draft.loading = false;
      draft.error = null;
      draft.value = action.response;
      return draft;
    case ACTIONS.MARKET_ERROR:
      draft[action.key] = false;
      draft.error = action.error;
      return draft;
    case ACTIONS.MARKET_SUGGESTION_ERROR:
      draft.suggestionLoading = false;
      draft.error = action.error;
      return draft;
    default:
      return draft;
  }
});

export default market;
